import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";

type CurrencyCode = "NGN" | "USD" | "CNY";

interface CurrencyContextType {
  currencyCode: CurrencyCode;
  setCurrencyCode: (code: CurrencyCode) => void;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined
);

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
};

export const CurrencyProvider = ({ children }: { children: ReactNode }) => {
  const [currencyCode, setCurrencyCodeState] = useState<"NGN" | "USD" | "CNY">(
    "NGN"
  );

  // Initialize from localStorage (persisted currency)
  useEffect(() => {
    const saved = localStorage.getItem("currencyCode");
    if (saved === "NGN" || saved === "USD" || saved === "CNY") {
      setCurrencyCodeState(saved);
    }
  }, []);

  const setCurrencyCode = (code: CurrencyCode) => {
    setCurrencyCodeState(code);
    // Persist selection to localStorage for cross-route consistency
    localStorage.setItem("currencyCode", code);
  };

  return (
    <CurrencyContext.Provider value={{ currencyCode, setCurrencyCode }}>
      {children}
    </CurrencyContext.Provider>
  );
};
